import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { map } from 'rxjs/operators';

@Injectable()
export class GovBrServico {
    Url: string;

    constructor(
        private http: Http,
    ) {
        
    }

    inicializarConfiguracoes() {
        return new Promise((resolve, reject) => {
            try {
                this.http.get("assets/config.json").subscribe(data => {
                    this.Url = data.json().BASE_WEB_API;

                    resolve(true);
                });
            } catch {
                reject(false);
            }
        });
    }

    UrlDeAutorizacao() {
        return new Promise((resolve, reject) => {
            this.http.get(this.Url + "/api/Login/GetGovBrAuthorizationUrl")
            .pipe(map((response: Response) => response.json()))
            .subscribe(
                data => {
                    localStorage.setItem('code_verifier', data.CodeVerifier);

                    resolve(data.RedirectUri);
                },
                error => {
                    reject(error);
                }
            );
        });
    }
}
